import { Directive, AfterContentChecked, ChangeDetectorRef } from '@angular/core';
import { DatatableComponent } from "@swimlane/ngx-datatable";

@Directive({ 
    selector: '[ngx-resize-watcher]' 
})
export class NgxResizeWatcherDirective implements AfterContentChecked {

    constructor(public _datatableComponent: DatatableComponent,
                public ref: ChangeDetectorRef) { }

    private latestWidth: number;

    ngAfterContentChecked() {
        if (this._datatableComponent && this._datatableComponent.element.clientWidth !== this.latestWidth) {
            this.latestWidth = this._datatableComponent.element.clientWidth;
            this._datatableComponent.recalculate();
            this.ref.markForCheck();
        }
    }
}